// use this file to get a configured jquery for ajax and crsf tokens etc...
// prob should use UJS if want to use non-ajax forms also
import $ from 'jquery'

$(function(){
  // always pass csrf tokens on ajax calls
  $.ajaxSetup({
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
  });
});

export default $
